import axios from 'axios';

export default {
    config() {
        const $this = this;
        axios.interceptors.request.use(config => {
            return config;
        }, error => {
            return Promise.reject(error);
        });
        axios.interceptors.response.use(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }, error => {
            store.commit('hideLoading', false);
            let response = error.response;
            return Promise.reject(response);
        });
    },
    // 合并多个参数组，并返回合并后的对象
    // 参数可以是单个对象，也可以是数组
    mergeParams(params) {
        params = params || {};
        if ((params instanceof Array) == false)
            params = [params];
        let merged = {};
        params.forEach(p => {
            if (p == null) return;
            Object.getOwnPropertyNames(p).forEach(pk => {
                if (pk.startsWith("__")) return;
                let value = p[pk];
                if (value != null && value instanceof Array)
                    value = value.join(",");
                merged[pk] = value;
            });
        });
        return merged;
    },

    options(params) {
        let options = {};
        options.params = this.mergeParams(params);

        return options;
    },

    get(url, params) {
        return axios.get(url, this.options(params));
    },

    post(url, data) {
        return axios.post(url, data, this.options());
    },
}